var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: [
        {
          ready: _vm.loadingIsReady,
          "is-loading": !_vm.loadingIsReady,
          fader: _vm.fader,
        },
        "loader",
      ],
    },
    [
      _vm.loadingIsReady
        ? _vm._t("default")
        : [
            _vm.showSpinner
              ? _c("i", { staticClass: "fa fa-spinner fa-pulse" })
              : _vm._e(),
            _vm._v(" "),
            _vm._t("isLoading"),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }